import { render, staticRenderFns } from "./CompanyOperatingHours.vue?vue&type=template&id=37a4b594"
import script from "./CompanyOperatingHours.vue?vue&type=script&lang=js"
export * from "./CompanyOperatingHours.vue?vue&type=script&lang=js"
import style0 from "./CompanyOperatingHours.vue?vue&type=style&index=0&id=37a4b594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports